import { createApiClient } from "@petci/api-client";

export const apiClient = createApiClient({ baseUrl: "" });
